module.exports = __webpack_public_path__ + "static/media/containted-objects.cf211402.svg";